import React, { useEffect, useState, useMemo } from "react";
import "./edit.css";
import { Select, DatePicker, Spin } from "antd";
import { MdOutlineFileUpload } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import {
  AiOutlineEye,
  AiOutlineDownload,
  AiOutlineDelete,
} from "react-icons/ai";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import Instance from "../../../AxiosConfig";
import { message, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import { LoadingOutlined } from "@ant-design/icons";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
const EditPage = () => {
  const { id } = useParams();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [scopeOfWork, setScopeOfWork] = useState("");
  const [clientName, setClientName] = useState("");
  const [standard, setStandard] = useState("");
  const [email, setEmail] = useState("");
  const [firstSurveillanceAudit, setFirstSurveillanceAudit] = useState("");
  const [secondSurveillanceAudit, setSecondSurveillanceAudit] = useState("");
  const [firstSurveillanceStatus, setFirstSurveillanceStatus] = useState([]);
  const [secondSurveillanceStatus, setSecondSurveillanceStatus] = useState([]);
  const [firstSurveillanceNotes, setFirstSurveillanceNotes] = useState("");
  const [secondSurveillanceNotes, setSecondSurveillanceNotes] = useState("");
  const [certificationNumber, setCertificationNumber] = useState("");
  const [status, setStatus] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [expiryDate, setExpiryDate] = useState("");
  const [registrationDate, setRegistrationDate] = useState("");
  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [showFileDownloadToast, setShowFileDownloadToast] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [agentData, setAgentData] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [alternateEmailInput, setAlternateEmailInput] = useState("");
  const [alternateEmails, setAlternateEmails] = useState([]);

const handleChange = (info) => {
  const realFile = info.file.originFileObj;

  if (realFile) {
    setImageUrl(URL.createObjectURL(realFile)); // ✅ valid Blob
    setLogoFile(realFile); // ✅ keep the real File object
    console.log("🟢 Logo file set:", realFile);
  } else {
    console.log("⚠️ No real File object found");
  }
};

  const countryOptions = useMemo(() => countryList().getData(), []);

  const uploadButton = (
    <div>
      <MdOutlineFileUpload size={28} />
      <div style={{ marginTop: 8 }}>Upload Logo</div>
    </div>
  );

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    addFiles(files);
  };
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const navigate = useNavigate();

   const beforeUpload = (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return Upload.LIST_IGNORE;
      }
      return true;
    };
  

  const fetchAgentData = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await Instance.get("/agents", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response);
      if (response.status == 200 || response.status == 201) {
        setAgentData(response?.data?.agents);
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  const fetchCertificationById = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await Instance.get(`/Certification/get/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response, "erty");
      if (response.status === 200 || response.status === 201) {
        const data = response.data?.certification;

        // Prepopulate all fields
        setCompanyName(data.companyName || "");
        setAddress(data.address || "");
        setScopeOfWork(data.scopeOfWork || "");
        setClientName(data.clientName || "");
        setStandard(data.standard || "");
        setEmail(data.email || "");
        setCertificationNumber(data.certificationNumber || "");
        setRegistrationDate(data.dateOfRegistration || "");
        setExpiryDate(data.certificationExpiryDate || "");
        setFirstSurveillanceAudit(data.firstSurveillanceAudit || "");
        setSecondSurveillanceAudit(data.secondSurveillanceAudit || "");
        setFirstSurveillanceStatus(
          data.firstSurveillanceStatus ? [data.firstSurveillanceStatus] : []
        );
        setSecondSurveillanceStatus(
          data.secondSurveillanceStatus ? [data.secondSurveillanceStatus] : []
        );
        setFirstSurveillanceNotes(data.firstSurveillanceNotes || "");
        setSecondSurveillanceNotes(data.secondSurveillanceNotes || "");
        setStatus(data.status ? [data.status] : []);
        setSelectedAgents(data.assignedAgent ? [data.assignedAgent._id] : []);
        const countryObj = countryOptions.find(
          (c) => c.label === data.country || c.value === data.country
        );
        setSelectedCountry(countryObj || null);
        setCity(data.city || "");
        setPhone(data.companyPhoneNumber || "");
        setAlternateEmails(data.alternateEmails || []);

        // For logo preview
        if (data.logo) setImageUrl(data.logo);

        if (data.attachments && data.attachments.length > 0) {
          const mappedFiles = data.attachments.map((attachment, index) => ({
            name: attachment.fileName || `Attachment-${index + 1}`,
            file: null,
            url: attachment.fileUrl,
            fileType: attachment.fileType,
          }));
          setUploadedFiles(mappedFiles);
        }
      }
    } catch (error) {
      console.error(
        "Error fetching certification:",
        error.response || error.message
      );
    }
  };

  useEffect(() => {
    fetchAgentData();
    if (id) fetchCertificationById();
  }, [id]);

  const AgentOptions = agentData.map((agent) => ({
    label: agent.agentName,
    value: agent._id,
  }));

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    addFiles(files);
  };

  const handleDragOver = (e) => e.preventDefault();

  const addFiles = (files) => {
    const newFiles = files.map((file) => ({
      name: file.name,
      file,
      url: null,
      fileType: file.type,
    }));

    // ✅ Append new files to previously uploaded ones
    setUploadedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  useEffect(() => {
    if (showSuccessMsg) {
      const timer = setTimeout(() => setShowSuccessMsg(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessMsg]);

  const clearAllFields = () => {
    setCompanyName("");
    setAddress("");
    setRegistrationDate("");
    setExpiryDate("");
    setScopeOfWork("");
    setClientName("");
    setStandard("");
    setEmail("");
    setFirstSurveillanceAudit("");
    setSecondSurveillanceAudit("");
    setCertificationNumber("");
    setStatus([]);
    setSelectedAgents([]);
    setUploadedFiles([]); // clear attachments
    setLogoFile(null); // clear logo
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("companyName", companyName);
      formData.append("address", address);
      formData.append("dateOfRegistration", registrationDate);
      formData.append("certificationExpiryDate", expiryDate);
      formData.append("scopeOfWork", scopeOfWork);
      formData.append("clientName", clientName);
      formData.append("standard", standard);
      formData.append("email", email);
      formData.append("firstSurveillanceAudit", firstSurveillanceAudit);
      formData.append("secondSurveillanceAudit", secondSurveillanceAudit);
      formData.append("certificationNumber", certificationNumber);
      formData.append("status", status);
      formData.append("assignedAgent", selectedAgents);
      formData.append("firstSurveillanceStatus", firstSurveillanceStatus);
      formData.append("secondSurveillanceStatus", secondSurveillanceStatus);
      formData.append("firstSurveillanceNotes", firstSurveillanceNotes);
      formData.append("secondSurveillanceNotes", secondSurveillanceNotes);
      formData.append("country", selectedCountry?.label || "");
      formData.append("city", city);
      formData.append("companyPhoneNumber", phone);
      alternateEmails.forEach((email) => {
        formData.append("alternateEmails", email);
      });

      if (logoFile) formData.append("logo", logoFile);

      uploadedFiles.forEach((fileObj) => {
        if (fileObj.file) formData.append("attachments", fileObj.file);
      });

      // 🟢 Log everything before sending
      console.log("🔍 Data being sent to PUT request:");
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }

      const response = await Instance.put(
        `/Certification/update/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      console.log(response, "response after put");
      if (response.status === 200 || response.status === 201) {
        console.log("Update success:", response);
        setShowSuccessMsg(true);
        navigate("/certification");
        clearAllFields();
      }
    } catch (error) {
      console.error("❌ Upload error:", error.response || error.message);
      setLoading(false);
    }
  };

  return (
    <div>
      {showSuccessMsg && (
        <div className="success-alert d-flex justify-content-between align-items-center">
          <span> certification details Uploaded successfully!</span>
          <span className="close-icon" onClick={() => setShowSuccessMsg(false)}>
            ×
          </span>
        </div>
      )}

      {showDeleteToast && (
        <div className="download-toast">
          <span>Certification details discarded successfully</span>
          <button
            className="toast-close-btn"
            onClick={() => setShowDeleteToast(false)}
          >
            <RxCross2 size={18} />
          </button>
        </div>
      )}
      <div className="company-form mt-4 p-4">
        <div className="details-page">
          <ImgCrop rotationSlider aspect={1} shape="round" quality={1}>
            <Upload
              name="logo"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              customRequest={({ onSuccess }) =>
                setTimeout(() => onSuccess("ok"), 0)
              } // disable auto-upload
              onChange={handleChange}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Company Logo"
                  className="profile-img-preview"
                  draggable={false}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </ImgCrop>
        </div>
      </div>
      <div className="company-form mt-4">
        {/* Your existing form fields */}

        <div className="row ">
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Company Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Agent</label>
            <Select
              className="custom-multi-select"
              options={AgentOptions}
              style={{ width: "100%" }}
              placeholder="select Agent"
              value={selectedAgents}
              onChange={(value) => setSelectedAgents(value)}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Standard</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Standard"
              value={standard}
              onChange={(e) => setStandard(e.target.value)}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Address</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Country</label>
            <Select
              showSearch
              className="custom-multi-select"
              style={{ width: "100%" }}
              placeholder="Select Country"
              options={countryOptions.map((c) => ({
                label: c.label,
                value: c.value,
              }))}
              value={selectedCountry}
              onChange={(value) => {
                const selected = countryOptions.find((c) => c.value === value);
                setSelectedCountry({
                  label: selected.label,
                  value: selected.value,
                });
              }}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">City</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Phone</label>
            <PhoneInput
              defaultCountry="in"
              value={phone}
              onChange={(phone) => setPhone(phone)}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Client Name</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Client Name"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Email</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Alternate Emails</label>
            <div
              className="form-control d-flex flex-wrap align-items-center"
              style={{ minHeight: "38px" }}
            >
              {alternateEmails.map((email, index) => (
                <span
                  key={index}
                  className="badge bg-primary me-2 mb-1 d-flex align-items-center"
                  style={{ fontSize: "0.85rem" }}
                >
                  {email}
                  <button
                    type="button"
                    onClick={() =>
                      setAlternateEmails(
                        alternateEmails.filter((_, i) => i !== index)
                      )
                    }
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: "0.6rem" }}
                  ></button>
                </span>
              ))}

              <input
                type="text"
                value={alternateEmailInput}
                onChange={(e) => setAlternateEmailInput(e.target.value)}
                onKeyDown={(e) => {
                  if (["Enter", ","].includes(e.key)) {
                    e.preventDefault();
                    const email = alternateEmailInput.trim();
                    if (email && !alternateEmails.includes(email)) {
                      setAlternateEmails([...alternateEmails, email]);
                      setAlternateEmailInput("");
                    }
                  }
                }}
                placeholder="Add alternate email and press Enter"
                style={{
                  border: "none",
                  outline: "none",
                  flex: 1,
                  minWidth: "150px",
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Date of Registration
            </label>
            <DatePicker
              className="form-control input-placeholder"
              value={registrationDate ? dayjs(registrationDate) : null}
              onChange={(date) =>
                setRegistrationDate(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              1st Surveillance Audit
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={
                firstSurveillanceAudit ? dayjs(firstSurveillanceAudit) : null
              }
              onChange={(date) =>
                setFirstSurveillanceAudit(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              1st Survielence Audit Status
            </label>
            <Select
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Pending", label: "Pending" },

                { value: "Completed", label: "Completed" },
              ]}
              value={firstSurveillanceStatus}
              onChange={(value) => setFirstSurveillanceStatus(value)}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              2nd Surveillance Audit
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={
                secondSurveillanceAudit ? dayjs(secondSurveillanceAudit) : null
              }
              onChange={(date) =>
                setSecondSurveillanceAudit(
                  date ? date.format("YYYY-MM-DD") : ""
                )
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              2nd Survielence Audit Status
            </label>
            <Select
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Pending", label: "Pending" },

                { value: "Completed", label: "Completed" },
              ]}
              value={secondSurveillanceStatus}
              onChange={(value) => setSecondSurveillanceStatus(value)}
              style={{ width: "100%" }}
            />
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Expiry Date
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={expiryDate ? dayjs(expiryDate) : null}
              onChange={(date) =>
                setExpiryDate(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Number
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Certification Number"
              value={certificationNumber}
              onChange={(e) => setCertificationNumber(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Status</label>
            <Select
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Active", label: "Active" },
                { value: "Inactive", label: "Inactive" }, // fix here
              ]}
              value={status}
              onChange={(value) => setStatus(value)}
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">Scope of Work</label>
          <textarea
            className="input-placeholder form-control"
            placeholder="Enter scope of work..."
            rows={4} // height of the textarea
            value={scopeOfWork}
            onChange={(e) => setScopeOfWork(e.target.value)}
          />
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">
            1st Survelliance Audit Notes
          </label>
          <textarea
            className="input-placeholder form-control"
            placeholder="1st Survelliance Audit Notes"
            rows={4} // height of the textarea
            value={firstSurveillanceNotes}
            onChange={(e) => setFirstSurveillanceNotes(e.target.value)}
          />
        </div>
        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">
            2nd Survelliance Audit Notes
          </label>
          <textarea
            className="input-placeholder form-control"
            placeholder="2nd Survelliance Audit Notes"
            rows={4} // height of the textarea
            value={secondSurveillanceNotes}
            onChange={(e) => setSecondSurveillanceNotes(e.target.value)}
          />
        </div>

        {/* Upload Section */}
        <div className="attachment-upload mt-4">
          <label className="input-label form-label">Attachment</label>
          <div
            className="upload-box"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <input
              id="fileInput"
              type="file"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <p
              className="upload-text"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Drag and Drop Attachment here or{" "}
              <span className="upload-link">click to Upload</span>{" "}
              <span className="upload-icon">
                <MdOutlineFileUpload />
              </span>
            </p>
          </div>
        </div>

        {/* File Details Table */}
        {uploadedFiles.length > 0 && (
          <div className="table-responsive">
            <table className="file-table">
              <thead>
                <tr>
                  <th>File Name</th>

                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {uploadedFiles.map((file, index) => (
                  <tr key={index}>
                    <td>{file.name}</td>

                    <td className="file-actions">
                      {/* 👁 View File */}
                      <AiOutlineEye
                        className="action-icon"
                        onClick={() => {
                          const fileURL = file.file
                            ? URL.createObjectURL(file.file)
                            : file.url; // ✅ use existing URL from backend
                          setModalImageSrc(fileURL);
                          setShowModal(true);
                        }}
                      />

                      <AiOutlineDownload
                        className="action-icon"
                        onClick={async () => {
                          try {
                            if (file.file) {
                              // For newly uploaded files
                              const url = URL.createObjectURL(file.file);
                              const link = document.createElement("a");
                              link.href = url;
                              link.download = file.name || "download";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              URL.revokeObjectURL(url);
                            } else if (file.url) {
                              // For files from backend (Cloudinary)
                              const response = await fetch(file.url);
                              const blob = await response.blob();
                              const url = window.URL.createObjectURL(blob);
                              const link = document.createElement("a");
                              link.href = url;
                              link.download = file.name || "download";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              window.URL.revokeObjectURL(url);
                            }
                          } catch (error) {
                            console.error("Download failed:", error);
                            alert("Failed to download file. Please try again.");
                          }
                        }}
                      />

                      {/* 🗑 Delete File (immediate) */}
                      <AiOutlineDelete
                        className="action-icon"
                        onClick={() =>
                          setUploadedFiles((prev) =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showFileDownloadToast && (
          <div className="download-toast">
            <span>File download started — please choose location</span>
            <button
              className="toast-close-btn"
              onClick={() => setShowFileDownloadToast(false)}
            >
              <RxCross2 size={18} />
            </button>
          </div>
        )}

        {showModal && (
          <div
            className="image-modal-overlay"
            onClick={() => setShowModal(false)}
          >
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {typeof modalImageSrc === "string" &&
              modalImageSrc.endsWith(".pdf") ? (
                <iframe
                  src={modalImageSrc}
                  title="PDF Preview"
                  width="100%"
                  height="500px"
                />
              ) : (
                <img
                  src={modalImageSrc}
                  alt="Preview"
                  style={{ width: "100%", borderRadius: "10px" }}
                />
              )}
              <button
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end gap-3 mt-4">
          <button
            className="discard-btn"
            onClick={() => navigate("/certification")}
          >
            Discard
          </button>

          <button className="save-btn" onClick={handleSubmit}>
            {loading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "#fff" }}
                    spin
                  />
                }
              />
            ) : (
              "Edit"
            )}{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPage;
